<template>
  <router-view />
</template>
<script>
import MixinLib from '@/libs/MixinLib'

export default {
  name: 'SignUpPage',

  mixins: [MixinLib],

  data: () => ({
  }),

  components: {
  }
}
</script>
